import {
  LOGIN,
  LOGOUT,
  SET_PREVIOUS_LOCATION,
  UNSET_PREVIOUS_LOCATION,
} from "store/auth/types";

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
      const userPayload = payload.userPayload;
      
      // If user is admin, use global roles. Otherwise, extract all roles from clientRoles
      if (!userPayload.isAdmin && userPayload.clientRoles) {
        const allRoles = [];
        userPayload.clientRoles.forEach(cr => {
          if (cr.roles && Array.isArray(cr.roles)) {
            cr.roles.forEach(role => {
              if (!allRoles.includes(role)) {
                allRoles.push(role);
              }
            });
          }
        });
        userPayload.roles = allRoles;
      }
      
      return {
        ...state,
        isAuthenticated: true,
        authObject: userPayload,
      };
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        authObject: null
      };
    case SET_PREVIOUS_LOCATION:
      return {
        ...state,
        previousLocation: payload.previousLocation,
      };
    case UNSET_PREVIOUS_LOCATION:
      return { ...state, previousLocation: null };
    default:
      return state;
  }
};

const initialState = {
  isAuthenticated: false,
  authObject: {
    email: null,
    name: null,
    role: null,
    token: null,
  },
  previousLocation: null,
};

export default authReducer;
